import axios from 'axios';
import './axiosConfig'; // Import to apply interceptors

/**
 * Order Service
 * Centralized API calls for order management and Razorpay integration
 */

/**
 * Create a new order with Razorpay
 * @param {Object} orderData - { user_profile_id, payment_method, order_notes }
 * @returns {Promise} Order data with razorpay_key_id
 */
export const createRazorpayOrder = async (orderData) => {
  try {
    const response = await axios.post('/api/checkout/create-order/', orderData);
    return response.data;
  } catch (error) {
    console.error('Error creating Razorpay order:', error);
    throw error;
  }
};

/**
 * Verify Razorpay payment signature
 * @param {Object} paymentData - { razorpay_order_id, razorpay_payment_id, razorpay_signature, order_id }
 * @returns {Promise} Verification result with updated order
 */
export const verifyPayment = async (paymentData) => {
  try {
    const response = await axios.post('/api/checkout/verify-payment/', paymentData);
    return response.data;
  } catch (error) {
    console.error('Error verifying payment:', error);
    throw error;
  }
};

/**
 * Fetch all orders for the authenticated user
 * @returns {Promise} Array of orders
 */
export const fetchOrders = async () => {
  try {
    const response = await axios.get('/api/orders/');
    return response.data;
  } catch (error) {
    console.error('Error fetching orders:', error);
    throw error;
  }
};

/**
 * Fetch details of a specific order
 * @param {string} orderId - UUID of the order
 * @returns {Promise} Order details
 */
export const fetchOrderDetails = async (orderId) => {
  try {
    const response = await axios.get(`/api/orders/${orderId}/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching order details:', error);
    throw error;
  }
};

/**
 * Cancel an order
 * @param {string} orderId - UUID of the order to cancel
 * @returns {Promise} Cancellation result with updated order
 */
export const cancelOrder = async (orderId) => {
  try {
    const response = await axios.post(`/api/orders/${orderId}/cancel/`);
    return response.data;
  } catch (error) {
    console.error('Error cancelling order:', error);
    throw error;
  }
};
